import type { SVGProps } from "react";
import { memo } from "react";
const FSxforLustre = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#1B660F" />
        <stop offset="100%" stopColor="#6CAE3E" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m63.588 39.998-.743-.666-6.586 6.398c-.051-.004-.099-.015-.15-.015a1.88 1.88 0 0 0-1.879 1.879 1.88 1.88 0 0 0 1.879 1.879 1.88 1.88 0 0 0 1.843-2.235zm-4.636.958.742-1.858a9.6 9.6 0 0 0-3.585-.689c-5.465 0-9.911 4.515-9.911 10.064h2c0-4.447 3.549-8.064 7.911-8.064.979 0 1.935.184 2.843.547m5.204 1.68-1.632 1.155a8.07 8.07 0 0 1 1.495 4.682h2c0-2.097-.644-4.115-1.863-5.837m-27.724 5.837h2.084l3.476-5.077-.938-1.325zm12.552-14.707h-2.055l-3.933 5.613-1.052 1.458 2.992 4.286a9.3 9.3 0 0 1 .718-2.08l-1.646-2.341zm-6.861 4.368-3.059-4.368h-2.169l4.133 5.826zm-10.124 1.132-2.769-1.061q-1.373-.517-2.11-.971-.738-.452-1.061-1.009-.324-.556-.324-1.462 0-1.605 1.061-2.472 1.062-.867 3.055-.867 2.044 0 4.684.931v-1.319a12.2 12.2 0 0 0-2.368-.764A11.3 11.3 0 0 0 29.773 30q-2.512 0-4.051 1.333t-1.54 3.481q0 1.58.932 2.653.932 1.075 2.924 1.851l3.003 1.165q1.553.596 2.252 1.346t.698 1.812q0 1.734-1.281 2.743-1.28 1.01-3.429 1.01-2.277 0-4.996-.984v1.32q2.253 1.087 5.125 1.087 2.77 0 4.465-1.423t1.695-3.728q0-1.578-.854-2.626-.853-1.05-2.717-1.774M13 30.44h10.068v1.372h-8.541v6.859h7.221v1.372h-7.221v8.334H13z"
      />
    </g>
  </svg>
);
const Memo = memo(FSxforLustre);
export default Memo;
